import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getSolutions } from '@/lib/api';
import { fadeUp, stagger } from '@/lib/motion';
import { PageHero, Section, SectionTitle } from '@/components/shared/Section';
import { ShieldCheck, ArrowRight, MessageCircle, Monitor, Tag, Tv, Users, Plane, Scale } from 'lucide-react';

const iconMap = { 'autoservicio-self-checkout': Monitor, 'esl-precios-digitales': Tag, 'carteleria-digital': Tv, 'gestion-filas': Users, 'aeropuertos': Plane, 'pesaje-industrial': Scale };

export default function SolutionsHub() {
  const [solutions, setSolutions] = useState([]);
  useEffect(() => { getSolutions().then(r => setSolutions(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <PageHero badge="SOLUCIONES ALLCOM" badgeIcon={ShieldCheck} h1="Soluciones integrales de tecnología en terreno" subtitle="Hardware + software + integración + operación 24/7. Todo en un solo proveedor para tu industria."
        primaryCTA={<Link to="/contacto" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold text-white bg-[#0EA5E9] rounded-xl hover:bg-sky-600 shadow-lg">Agendar demo <ArrowRight className="w-4 h-4" /></Link>}
        secondaryCTA={<a href="https://wa.me/56975294340" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-6 py-3.5 text-sm font-semibold text-emerald-400 border border-emerald-400/30 rounded-xl hover:bg-emerald-400/10"><MessageCircle className="w-4 h-4" /> WhatsApp</a>}
      />
      <Section>
        <motion.div variants={stagger} className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {solutions.map((s) => {
            const Icon = iconMap[s.slug] || Monitor;
            return (
              <motion.div key={s.slug} variants={fadeUp}>
                <Link to={`/soluciones/${s.slug}`} className="group block p-6 sm:p-8 rounded-2xl bg-white border border-slate-200 shadow-[0_10px_30px_rgba(2,6,23,0.08)] card-hover h-full">
                  <div className="w-12 h-12 rounded-xl bg-sky-50 border border-sky-100 flex items-center justify-center mb-4 group-hover:bg-[#0EA5E9] group-hover:border-[#0EA5E9] transition-colors">
                    <Icon className="w-6 h-6 text-[#0EA5E9] group-hover:text-white transition-colors" />
                  </div>
                  <h3 className="text-lg font-semibold mb-2 group-hover:text-[#0EA5E9] transition-colors" style={{fontFamily:'Syne,sans-serif'}}>{s.title}</h3>
                  <p className="text-sm text-[#64748B] leading-relaxed">{s.description}</p>
                </Link>
              </motion.div>
            );
          })}
        </motion.div>
      </Section>
    </div>
  );
}
